import { Namespace, TFuncKey, useTranslation } from 'react-i18next';

import useAppQuery from 'hooks/useAppQuery';
import useAppUser from 'hooks/useAppUser';
import { API_MAX_LIMIT } from 'services/API.constants';
import { customDataFieldsQuery } from './fields/customDataFieldsQuery';

const VARIABLES = {
  lead: [
    {
      value: '[$LEAD_UID$]',
      label: 'form.editor.variables.LEAD_UID',
    },
    {
      value: '[$LEAD_EXTERNAL_ID$]',
      label: 'form.editor.variables.LEAD_EXTERNAL_ID',
    },
    {
      value: '[$LEAD_CONTRACT_URL$]',
      label: 'form.editor.variables.LEAD_CONTRACT_URL',
    },
    {
      value: '[$LEAD_AGREEMENT_URL$]',
      label: 'form.editor.variables.LEAD_AGREEMENT_URL',
    },
    {
      value: '[$LEAD_SOURCE$]',
      label: 'form.editor.variables.LEAD_SOURCE',
    },
    {
      value: '[$LEAD_CHECKIN$]',
      label: 'form.editor.variables.LEAD_CHECKIN',
    },
    {
      value: '[$LEAD_CHECKOUT$]',
      label: 'form.editor.variables.LEAD_CHECKOUT',
    },
    {
      value: '[$LEAD_CHECKIN_TIME$]',
      label: 'form.editor.variables.LEAD_CHECKIN_TIME',
    },
    {
      value: '[$LEAD_CHECKOUT_TIME$]',
      label: 'form.editor.variables.LEAD_CHECKOUT_TIME',
    },
    {
      value: '[$LEAD_GUESTS$]',
      label: 'form.editor.variables.LEAD_GUESTS',
    },
    {
      value: '[$LEAD_ADULT_COUNT$]',
      label: 'form.editor.variables.LEAD_ADULT_COUNT',
    },
    {
      value: '[$LEAD_CHILDREN_COUNT$]',
      label: 'form.editor.variables.LEAD_CHILDREN_COUNT',
    },
    {
      value: '[$LEAD_NIGHTS$]',
      label: 'form.editor.variables.LEAD_NIGHTS',
    },
    {
      value: '[$LEAD_NOTES$]',
      label: 'form.editor.variables.LEAD_NOTES',
    },
    {
      value: '[$LEAD_ARRIVAL_DATE$]',
      label: 'form.editor.variables.LEAD_ARRIVAL_DATE',
    },
    {
      value: '[$LEAD_DEPARTURE_DATE$]',
      label: 'form.editor.variables.LEAD_DEPARTURE_DATE',
    },
    {
      value: '[$LEAD_ARRIVAL_TIME$]',
      label: 'form.editor.variables.LEAD_ARRIVAL_TIME',
    },
    {
      value: '[$LEAD_DEPARTURE_TIME$]',
      label: 'form.editor.variables.LEAD_DEPARTURE_TIME',
    },
    {
      value: '[$LEAD_CHANNEL$]',
      label: 'form.editor.variables.LEAD_CHANNEL',
    },
    {
      value: '[$LEAD_CHANNEL_LOGO$]',
      label: 'form.editor.variables.LEAD_CHANNEL_LOGO',
    },
    {
      value: '[$LEAD_PINCODE$]',
      label: 'form.editor.variables.LEAD_PINCODE',
    },
    {
      value: '[$LEAD_PINCODE_URL$]',
      label: 'form.editor.variables.LEAD_PINCODE_URL',
    },
    {
      value: '[$LEAD_TIME_BEFORE_CHECKIN_DAYS$]',
      label: 'form.editor.variables.LEAD_TIME_BEFORE_CHECKIN_DAYS',
    },
    {
      value: '[$LEAD_DIRECT_HOLD_FUNCTION_CALL$]',
      label: 'form.editor.variables.LEAD_DIRECT_HOLD_FUNCTION_CALL',
    },
    {
      value: '[$SECURITY_DEPOSIT_DUE_DATE$]',
      label: 'form.editor.variables.SECURITY_DEPOSIT_DUE_DATE',
    },
    {
      value: '[$AGENT_SIGNATURE$]',
      label: 'form.editor.variables.AGENT_SIGNATURE',
    },
    {
      value: '[$CHECKIN_INSTRUCTIONS$]',
      label: 'form.editor.variables.CHECKIN_INSTRUCTIONS',
    },
    {
      value: '[$SECURE_GUIDEBOOK_LINK$]',
      label: 'form.editor.variables.SECURE_GUIDEBOOK_LINK',
    },
    {
      value: '[$EMPLOYEE_NAME$]',
      label: 'form.editor.variables.EMPLOYEE_NAME',
    },
    {
      value: '[$EMPLOYEE_FIRST_NAME$]',
      label: 'form.editor.variables.EMPLOYEE_FIRST_NAME',
    },
    {
      value: '[$EMPLOYEE_EMAIL$]',
      label: 'form.editor.variables.EMPLOYEE_EMAIL',
    },
    {
      value: '[$EMPLOYEE_CELL_PHONE_NUMBER$]',
      label: 'form.editor.variables.EMPLOYEE_CELL_PHONE_NUMBER',
    },
    {
      value: '[$OWNER_NAME$]',
      label: 'form.editor.variables.OWNER_NAME',
    },
    {
      value: '[$OWNER_FIRSTNAME$]',
      label: 'form.editor.variables.OWNER_FIRSTNAME',
    },
    {
      value: '[$OWNER_EMAIL$]',
      label: 'form.editor.variables.OWNER_EMAIL',
    },
    {
      value: '[$OWNER_CELL_PHONE_NUMBER$]',
      label: 'form.editor.variables.OWNER_CELL_PHONE_NUMBER',
    },
  ],
  guest: [
    {
      value: '[$GUEST_NAME$]',
      label: 'form.editor.variables.GUEST_NAME',
    },
    {
      value: '[$GUEST_FIRST_NAME$]',
      label: 'form.editor.variables.GUEST_FIRST_NAME',
    },
    {
      value: '[$GUEST_LAST_NAME$]',
      label: 'form.editor.variables.GUEST_LAST_NAME',
    },
    {
      value: '[$GUEST_EMAIL$]',
      label: 'form.editor.variables.GUEST_EMAIL',
    },
    {
      value: '[$GUEST_ACCOUNT_LINK$]',
      label: 'form.editor.variables.GUEST_ACCOUNT_LINK',
    },
    {
      value: '[$GUEST_PHONE_NUMBER$]',
      label: 'form.editor.variables.GUEST_PHONE_NUMBER',
    },
    {
      value: '[$GUEST_CELL_PHONE_NUMBER$]',
      label: 'form.editor.variables.GUEST_CELL_PHONE_NUMBER',
    },
    {
      value: '[$GUEST_ADDRESS$]',
      label: 'form.editor.variables.GUEST_ADDRESS',
    },
    {
      value: '[$GUEST_ID_URL$]',
      label: 'form.editor.variables.GUEST_ID_URL',
    },
    {
      value: '[$GUEST_INFO_URL$]',
      label: 'form.editor.variables.GUEST_INFO_URL',
    },
    {
      value: '[$PET_COUNT$]',
      label: 'form.editor.variables.PET_COUNT',
    },
  ],
  order: [
    {
      value: '[$ORDER_UID$]',
      label: 'form.editor.variables.ORDER_UID',
    },
    {
      value: '[$ORDER_RENT$]',
      label: 'form.editor.variables.ORDER_RENT',
    },
    {
      value: '[$ORDER_DEPOSIT_PAYMENT$]',
      label: 'form.editor.variables.ORDER_DEPOSIT_PAYMENT',
    },
    {
      value: '[$ORDER_CLEANING_FEE$]',
      label: 'form.editor.variables.ORDER_CLEANING_FEE',
    },
    {
      value: '[$ORDER_FEE$]',
      label: 'form.editor.variables.ORDER_FEE',
    },
    {
      value: '[$ORDER_BALANCE$]',
      label: 'form.editor.variables.ORDER_BALANCE',
    },
    {
      value: '[$ORDER_TOTAL$]',
      label: 'form.editor.variables.ORDER_TOTAL',
    },
    {
      value: '[$ORDER_STATEMENT$]',
      label: 'form.editor.variables.ORDER_STATEMENT',
    },
    {
      value: '[$ORDER_TOTAL_WITHOUT_SD$]',
      label: 'form.editor.variables.ORDER_TOTAL_WITHOUT_SD',
    },
    {
      value: '[$SECURITY_DEPOSIT_AMOUNT$]',
      label: 'form.editor.variables.SECURITY_DEPOSIT_AMOUNT',
    },
    {
      value: '[$ORDER_TOTAL_DUE_DATE$]',
      label: 'form.editor.variables.ORDER_TOTAL_DUE_DATE',
    },
    {
      value: '[$PAYMENT_LINK_URL$]',
      label: 'form.editor.variables.PAYMENT_LINK_URL',
    },
    {
      value: '[$BOOK_SERVICES_URL$]',
      label: 'form.editor.variables.BOOK_SERVICES_URL',
    },
  ],
  agency: [
    {
      value: '[$AGENCY_LOGO$]',
      label: 'form.editor.variables.AGENCY_LOGO',
    },
    {
      value: '[$AGENCY_NAME$]',
      label: 'form.editor.variables.AGENCY_NAME',
    },
    {
      value: '[$AGENCY_SIGNATURE$]',
      label: 'form.editor.variables.AGENCY_SIGNATURE',
    },
  ],
  property: [
    {
      value: '[$PROPERTY_NAME$]',
      label: 'form.editor.variables.PROPERTY_NAME',
    },
    {
      value: '[$PROPERTY_INTERNAL_NAME$]',
      label: 'form.editor.variables.PROPERTY_INTERNAL_NAME',
    },
    {
      value: '[$PROPERTY_PICTURE$]',
      label: 'form.editor.variables.PROPERTY_PICTURE',
    },
    {
      value: '[$PROPERTY_WEBLINK$]',
      label: 'form.editor.variables.PROPERTY_WEBLINK',
    },
    {
      value: '[$PROPERTY_GUIDEBOOKURL$]',
      label: 'form.editor.variables.PROPERTY_GUIDEBOOKURL',
    },
    {
      value: '[$PROPERTY_GUIDEBOOK_RECOMMENDATIONS_ONLY_URL$]',
      label:
        'form.editor.variables.PROPERTY_GUIDEBOOK_RECOMMENDATIONS_ONLY_URL',
    },
    {
      value: '[$PROPERTY_MIN_STAY$]',
      label: 'form.editor.variables.PROPERTY_MIN_STAY',
    },
    {
      value: '[$PROPERTY_UID$]',
      label: 'form.editor.variables.PROPERTY_UID',
    },
    {
      value: '[$PROPERTY_UNIT_NAME$]',
      label: 'form.editor.variables.PROPERTY_UNIT_NAME',
    },
    {
      value: '[$PROPERTY_ADDRESS$]',
      label: 'form.editor.variables.PROPERTY_ADDRESS',
    },
    {
      value: '[$PROPERTY_STREET$]',
      label: 'form.editor.variables.PROPERTY_STREET',
    },
    {
      value: '[$PROPERTY_ZIPCODE$]',
      label: 'form.editor.variables.PROPERTY_ZIPCODE',
    },
    {
      value: '[$PROPERTY_STATE$]',
      label: 'form.editor.variables.PROPERTY_STATE',
    },
    {
      value: '[$PROPERTY_CITY$]',
      label: 'form.editor.variables.PROPERTY_CITY',
    },
    {
      value: '[$PROPERTY_PUBLIC_LINK$]',
      label: 'form.editor.variables.PROPERTY_PUBLIC_LINK',
    },
    {
      value: '[$PROPERTY_ACCOUNTING_ID$]',
      label: 'form.editor.variables.PROPERTY_ACCOUNTING_ID',
    },
    {
      value: '[$PROPERTY_WIFI_NETWORK$]',
      label: 'form.editor.variables.PROPERTY_WIFI_NETWORK',
    },
    {
      value: '[$PROPERTY_WIFI_PASSWORD$]',
      label: 'form.editor.variables.PROPERTY_WIFI_PASSWORD',
    },
  ],
  transaction: [
    {
      value: '[$TRANSACTION_STATUS$]',
      label: 'form.editor.variables.TRANSACTION_STATUS',
    },
    {
      value: '[$TRANSACTION_ERROR_MESSAGE$]',
      label: 'form.editor.variables.TRANSACTION_ERROR_MESSAGE',
    },
    {
      value: '[$TRANSACTION_TYPE$]',
      label: 'form.editor.variables.TRANSACTION_TYPE',
    },
    {
      value: '[$TRANSACTION_ID$]',
      label: 'form.editor.variables.TRANSACTION_ID',
    },
    {
      value: '[$TRANSACTION_AMOUNT$]',
      label: 'form.editor.variables.TRANSACTION_AMOUNT',
    },
    {
      value: '[$GUIDEBOOK_ID$]',
      label: 'form.editor.variables.GUIDEBOOK_ID',
    },
  ],
  adjustment: [
    {
      value: '[$ADJUSTMENT_TYPE$]',
      label: 'form.editor.variables.ADJUSTMENT_TYPE',
    },
    {
      value: '[$ADJUSTMENT_VALUE$]',
      label: 'form.editor.variables.ADJUSTMENT_VALUE',
    },
  ],
  statement: [
    {
      value: '[$STATEMENT_ID$]',
      label: 'form.editor.variables.STATEMENT_ID',
    },
    {
      value: '[$STATEMENT_TITLE$]',
      label: 'form.editor.variables.STATEMENT_TITLE',
    },
  ],
  user: [
    {
      value: '[$USER_LOGIN_URL$]',
      label: 'form.editor.variables.USER_LOGIN_URL',
    },
  ],
  job: [
    {
      value: '[$JOB_START_TIME$]',
      label: 'form.editor.variables.JOB_START_TIME',
    },
    {
      value: '[$JOB_END_TIME$]',
      label: 'form.editor.variables.JOB_END_TIME',
    },
    {
      value: '[$JOB_DATE$]',
      label: 'form.editor.variables.JOB_DATE',
    },
    {
      value: '[$JOB_MARK_AS_DONE_URL$]',
      label: 'form.editor.variables.JOB_MARK_AS_DONE_URL',
    },
    {
      value: '[$JOB_MARK_AS_SCHEDULED_URL$]',
      label: 'form.editor.variables.JOB_MARK_AS_SCHEDULED_URL',
    },
  ],
  service: [
    {
      value: '[$SERVICE_TITLE$]',
      label: 'form.editor.variables.SERVICE_TITLE',
    },
  ],
  review: [
    {
      value: '[$REVIEW_NAME$]',
      label: 'form.editor.variables.REVIEW_NAME',
    },
    {
      value: '[$REVIEW_CONTENT$]',
      label: 'form.editor.variables.REVIEW_CONTENT',
    },
  ],
  service_provider: [
    {
      value: '[$SERVICE_PROVIDER_COMPANY_NAME$]',
      label: 'form.editor.variables.SERVICE_PROVIDER_COMPANY_NAME',
    },
    {
      value: '[$SERVICE_PROVIDER_FIRSTNAME$]',
      label: 'form.editor.variables.SERVICE_PROVIDER_FIRSTNAME',
    },
    {
      value: '[$SERVICE_PROVIDER_EMAIL$]',
      label: 'form.editor.variables.SERVICE_PROVIDER_EMAIL',
    },
    {
      value: '[$SERVICE_PROVIDER_CELL_PHONE_NUMBER$]',
      label: 'form.editor.variables.SERVICE_PROVIDER_CELL_PHONE_NUMBER',
    },
  ],
  message: [
    {
      value: '[$INBOX_THREAD_URL$]',
      label: 'form.editor.variables.INBOX_THREAD_URL',
    },
    {
      value: '[$NEW_MESSAGE_CONTENT$]',
      label: 'form.editor.variables.NEW_MESSAGE_CONTENT',
    },
  ],
} as const satisfies Record<
  string,
  { value: string; label: TFuncKey<Namespace<'en'>> }[]
>;

export type AvailableVariableTypes = keyof typeof VARIABLES | 'custom';

const useTemplateVariables = (variableTypes: AvailableVariableTypes[]) => {
  const { t } = useTranslation();
  const { agencyUid } = useAppUser();
  const { data: customData, isFetching: isFetchingCustomData } = useAppQuery({
    ...customDataFieldsQuery({
      agencyUid: agencyUid!,
      pageIndex: 0,
      pageSize: API_MAX_LIMIT,
      sorting: [],
    }),

    // Only needed if custom variables is required, otherwise we don't need to
    // fetch and wait for this query
    enabled: variableTypes.includes('custom'),
  });

  const variables = variableTypes.flatMap((type) => {
    if (type === 'custom') {
      return (customData?.data ?? []).map((data) => ({
        label: `${data.name} [Custom]`,
        value: data.variable,
      }));
    }

    return VARIABLES[type].map((option) => ({
      ...option,
      label: t(option.label),
    }));
  });

  return {
    variables,
    isLoading: isFetchingCustomData,
  };
};

export default useTemplateVariables;
